import { render, staticRenderFns } from "./catalog-list.vue?vue&type=template&id=8e56e00c&scoped=true&"
import script from "./catalog-list.vue?vue&type=script&lang=js&"
export * from "./catalog-list.vue?vue&type=script&lang=js&"
import style0 from "./catalog-list.vue?vue&type=style&index=0&id=8e56e00c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e56e00c",
  null
  
)

export default component.exports